export const css = {
    root: '_1BuoI4Au',
    unearnedInstructions: 'ibhwcjLC',
    printInstructions: '_1d2V97R2',
    printBtn: '_3dZapGxV',
    ' _key': 'certificate/certificate'
};
export default css;
